import { RouteConfig } from 'vue-router';
import ManagementManagedServices from '@/modules/tickets/requirement/management-managed-services/views/ManagementManagedServices.vue';
import LinkManagement from '@/modules/tickets/incidents/link-management/views/LinkManagement.vue';
import NetworkSecurityInternetIncident from '@/modules/tickets/incidents/network-security-internet/views/NetworkSecurityInternetIncident.vue';
import ProcessingAndManagedManagement from '@/modules/tickets/incidents/processing-and-managed-management/views/ProcessingAndManagedManagement.vue';
import { TicketsDashboard, TicketsDayco } from '@/components/tickets';
import TicketsCreateAccess from '@/components/tickets/tickets-form/TicketsCreateAccess.vue';
import TicketsModifyAccess from '@/components/tickets/tickets-form/TicketsModifyAccess.vue';
import PDTDetail from '@/modules/tickets/access-permissions/views/PDTDetail.vue';
import AccessPermissionDashboard from '@/modules/tickets/access-permissions/views/AccessPermissions.vue';
import TapeChanges from '@/components/tickets/tape-changes/views/TapeChanges.vue';
import TicketsTapeManagement from '@/components/tickets/tickets-form/TicketsTapeManagement.vue';
import TicketsRemoteAssistance from '@/components/tickets/tickets-form/TicketsRemoteAssistance.vue';
import NetworkSecurityInternet from '@/modules/tickets/requirement/network-security-internet/views/NetworkSecurityInternet.vue';

export const ticketsRouter: RouteConfig[] = [
    {
        path: 'tickets',
        name: 'tickets',
        component: TicketsDashboard,
    },
    {
        path: 'tickets/access/create',
        name: 'access-create',
        component: TicketsCreateAccess,
        props: true,
    },
    {
        path: 'tickets/access/modify',
        name: 'access-modify',
        component: TicketsModifyAccess,
        props: true,
    },
    {
        path: 'tickets/access/:id',
        name: 'access',
        component: PDTDetail,
        props: true,
    },
    {
        path: 'access-permissions',
        name: 'access-permissions',
        component: AccessPermissionDashboard,
        props: true,
    },
    {
        path: 'tape-management',
        name: 'tape-changes',
        component: TapeChanges,
        props: true,
    },
    {
        path: 'tickets/tape-management',
        name: 'tape-management',
        component: TicketsTapeManagement,
    },
    {
        path: 'tickets/remote-assistance',
        name: 'remote-assistance',
        component: TicketsRemoteAssistance,
    },
    {
        path: 'tickets/network-security-and-internet',
        name: 'network-security-and-internet',
        component: NetworkSecurityInternet,
    },
    {
        path: 'dayco-tickets',
        name: 'dayco-tickets',
        component: TicketsDayco,
        props: true,
    },
    {
        path: 'tickets/management-and-managed-services',
        name: 'management-and-managed-services',
        component: ManagementManagedServices,
    },
    {
        path: 'tickets/link-management',
        name: 'link-management',
        component: LinkManagement,
    },
    {
        path: 'tickets/network-security-internet-incident',
        name: 'network-security-internet-incident',
        component: NetworkSecurityInternetIncident,
    },
    {
        path: 'tickets/processing-and-managed-management',
        name: 'processing-and-managed-management',
        component: ProcessingAndManagedManagement,
    },
];
